export default __webpack_public_path__ + "static/gowrite-live-f2261cdabf56dc2782b3f68b94d704e1.png";